import PropTypes from 'prop-types';
import { useEffect } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { sendEmail } from 'Redux/verification/verificationThunks';
import { t } from 'Utils/localization/i18next';
import { captureSentry } from 'Utils/sentry';
import { showToast } from 'Utils/toastUtils';

const DashboardVerificationBannerContainer = props => {
  // Show email verification banner if email is not verified
  useEffect(() => {
    if (!props.verified.email && props.email) {
      showToast(
        t('dashboard.emailVerification.title'),
        t('dashboard.emailVerification.body'),
        {
          label: t('dashboard.emailVerification.verify'),
          callbackOrHref: props.sendEmail
        }
      );
    }
  }, [props.verified.email, props.email]);

  // Show phone verification error messages
  useEffect(() => {
    if (!props.isOTPSent && props.otpSentFrom === 'dashboard') {
      if (props.otpSentError) {
        showToast(
          t('dashboard.mobileVerification.errorTitle'),
          props.otpSentError,
          {
            label: t('dashboard.mobileVerification.editMobile'),
            callbackOrHref: () => {
              const TAB_BUTTON_SELECTOR =
                '[aria-controls="tab-button-account"]';
              const EDIT_BUTTON_ID = `${props.profileType}-dashboard-account-personal-form-link`;

              const tabButton = document.querySelector(TAB_BUTTON_SELECTOR);
              tabButton?.click();

              const editButton = document.getElementById(EDIT_BUTTON_ID);
              editButton?.click();
              tabButton?.scrollIntoView();

              if (!editButton) {
                captureSentry(
                  `DashboardVerificationBannerContainer: ${EDIT_BUTTON_ID} cannot be clicked`
                );
              }
            }
          }
        );
      } else {
        showToast(
          t('dashboard.mobileVerification.errorTitle'),
          t('dashboard.mobileVerification.errorBody')
        );
      }
    }
  }, [props.isOTPSent, props.otpSentFrom, props.otpSentError]);

  return null;
};

DashboardVerificationBannerContainer.propTypes = {
  verified: PropTypes.object,
  isOTPSent: PropTypes.bool,
  otpSentError: PropTypes.string,
  otpSentFrom: PropTypes.string,
  sendEmail: PropTypes.func,
  email: PropTypes.string,
  profileType: PropTypes.string
};

const mapStateToProps = state => {
  return {
    verified: {
      email: state.verification.emailVerifiedStatus
    },
    isOTPSent: state.verification.otpSentStatus,
    otpSentError: state.verification.otpSentError,
    otpSentFrom: state.verification.otpSentFrom,
    email: state.profile.email,
    profileType: state.profile.profileType
  };
};

const mapDispatchToProps = dispatch => {
  return bindActionCreators(
    {
      sendEmail
    },
    dispatch
  );
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(DashboardVerificationBannerContainer);
